import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

const props = {
  layout: "constrained",
  width: 32,
  height: 32,
  placeholder: "none",
  "aria-hidden": true,
}

export const fallback = (
  <StaticImage {...props} alt="plugin icon" src="fallback-plugin-icon.png" />
)

export const imagePlugin = (
  <StaticImage
    {...props}
    alt="gatsby-image-plugin icon"
    src="gatsby-image-plugin-icon.png"
  />
)

export const algolia = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-algolia icon"
    src="gatsby-plugin-algolia-plugin-icon.png"
  />
)

export const emotion = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-emotion icon"
    src="gatsby-plugin-emotion-plugin-icon.png"
  />
)

export const googleAnalytics = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-google-analytics icon"
    src="gatsby-plugin-google-analytics-plugin-icon.png"
  />
)

export const googleTagManager = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-google-tagmanager icon"
    src="gatsby-plugin-google-tagmanager-plugin-icon.png"
  />
)

export const hotjar = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-hotjar icon"
    src="gatsby-plugin-hotjar-plugin-icon.png"
  />
)

export const imgix = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-imgix icon"
    src="gatsby-plugin-imgix-icon.png"
  />
)

export const less = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-less"
    src="gatsby-plugin-less-plugin-icon.png"
  />
)

export const linaria = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-linaria"
    src="gatsby-plugin-linaria-plugin-icon.png"
  />
)

export const materialUI = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-material-ui"
    src="gatsby-plugin-material-ui-plugin-icon.png"
  />
)

export const matomo = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-matomo"
    src="gatsby-plugin-matomo-plugin-icon.png"
  />
)

export const mdx = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-mdx"
    src="gatsby-plugin-mdx-plugin-icon.png"
  />
)

export const mixpanel = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-mixpanel"
    src="gatsby-plugin-mixpanel-plugin-icon.png"
  />
)

export const postcss = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-postcss"
    src="gatsby-plugin-postcss-plugin-icon.png"
  />
)

export const purgecss = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-purgecss"
    src="gatsby-plugin-purgecss-plugin-icon.png"
  />
)

export const s3 = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-s3"
    src="gatsby-plugin-s3-plugin-icon.png"
  />
)

export const sass = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-sass"
    src="gatsby-plugin-sass-plugin-icon.png"
  />
)

export const segment = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-segment-js"
    src="gatsby-plugin-segment-js-plugin-icon.png"
  />
)

export const sharp = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-sharp"
    src="gatsby-plugin-sharp-plugin-icon.png"
  />
)

export const sitemap = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-sitemap"
    src="gatsby-plugin-sitemap-plugin-icon.png"
  />
)

export const styledComponents = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-styled-components"
    src="gatsby-plugin-styled-components-plugin-icon.png"
  />
)

export const agilitycms = (
  <StaticImage
    {...props}
    alt="gatsby-source-agilitycms"
    src="gatsby-source-agilitycms-plugin-icon.png"
  />
)

export const airtable = (
  <StaticImage
    {...props}
    alt="gatsby-source-airtable"
    src="gatsby-source-airtable-plugin-icon.png"
  />
)

export const bigcommerce = (
  <StaticImage
    {...props}
    alt="gatsby-source-bigcommerce"
    src="gatsby-source-bigcommerce-plugin-icon.png"
  />
)

export const cloudinary = (
  <StaticImage
    {...props}
    alt="gatsby-source-cloudinary"
    src="gatsby-source-cloudinary-icon.png"
  />
)

export const contentful = (
  <StaticImage
    {...props}
    alt="gatsby-source-contentful"
    src="gatsby-source-contentful-plugin-icon.png"
  />
)

export const contentstack = (
  <StaticImage
    {...props}
    alt="gatsby-source-contentstack"
    src="gatsby-source-contentstack-icon.png"
  />
)

export const datocms = (
  <StaticImage
    {...props}
    alt="gatsby-source-datocms"
    src="gatsby-source-datocms-plugin-icon.png"
  />
)

export const drupal = (
  <StaticImage
    {...props}
    alt="gatsby-source-drupal"
    src="gatsby-source-drupal-plugin-icon.png"
  />
)

export const filesystem = (
  <StaticImage
    {...props}
    alt="gatsby-source-filesystem"
    src="gatsby-source-filesystem-plugin-icon.png"
  />
)

export const flotiq = (
  <StaticImage
    {...props}
    alt="gatsby-source-flotiq"
    src="gatsby-source-flotiq-plugin-icon.png"
  />
)

export const graphcms = (
  <StaticImage
    {...props}
    alt="gatsby-source-graphcms"
    src="gatsby-source-graphcms-plugin-icon.png"
  />
)

export const kentico = (
  <StaticImage
    {...props}
    alt="gatsby-source-kentico"
    src="gatsby-source-kentico-plugin-icon.png"
  />
)

export const netlify = (
  <StaticImage
    {...props}
    alt="gatsby-source-netlify"
    src="gatsby-source-netlify-plugin-icon.png"
  />
)

export const prismic = (
  <StaticImage
    {...props}
    alt="gatsby-source-prismic"
    src="gatsby-source-prismic-icon.png"
  />
)

export const sanity = (
  <StaticImage
    {...props}
    alt="gatsby-source-sanity"
    src="gatsby-source-sanity-plugin-icon.png"
  />
)

export const shopify = (
  <StaticImage
    {...props}
    alt="gatsby-source-shopify"
    src="gatsby-source-shopify-plugin-icon.png"
  />
)

export const snipcart = (
  <StaticImage
    {...props}
    alt="gatsby-source-snipcart"
    src="gatsby-source-snipcart-plugin-icon.png"
  />
)

export const strapi = (
  <StaticImage
    {...props}
    alt="gatsby-source-strapi"
    src="gatsby-source-strapi-plugin-icon.png"
  />
)

export const stripe = (
  <StaticImage
    {...props}
    alt="gatsby-source-stripe"
    src="gatsby-source-stripe-plugin-icon.png"
  />
)

export const vimeo = (
  <StaticImage
    {...props}
    alt="gatsby-source-vimeo"
    src="gatsby-source-vimeo-icon.png"
  />
)

export const wordpress = (
  <StaticImage
    {...props}
    alt="gatsby-source-wordpress"
    src="gatsby-source-wordpress-plugin-icon.png"
  />
)

export const auth0 = (
  <StaticImage
    {...props}
    alt="gatsby-theme-auth0-ts"
    src="gatsby-theme-auth0-ts-plugin-icon.png"
  />
)

export const remark = (
  <StaticImage
    {...props}
    alt="gatsby-transformer-remark"
    src="gatsby-transformer-remark-plugin-icon.png"
  />
)

export const buttercms = (
  <StaticImage
    {...props}
    alt="gatsby-source-buttercms"
    src="gatsby-source-buttercms-icon.png"
  />
)

export const hubspot = (
  <StaticImage
    {...props}
    alt="gatsby-source-hubspot"
    src="gatsby-source-hubspot-icon.png"
  />
)

export const storyblok = (
  <StaticImage
    {...props}
    alt="gatsby-source-storyblok"
    src="gatsby-source-storyblok-icon.png"
  />
)

export const vanillaExtract = (
  <StaticImage
    {...props}
    alt="gatsby-plugin-vanilla-extract"
    src="gatsby-plugin-vanilla-extract-icon.png"
  />
)
